import { withSvgIcon } from './withSvgIcon';

export const NavBarDocs = withSvgIcon(
  <path
    d="M12.5 4H8C7.05719 4 6.58579 4 6.29289 4.29289C6 4.58579 6 5.05719 6 6V18C6 18.9428 6 19.4142 6.29289 19.7071C6.58579 20 7.05719 20 8 20H16C16.9428 20 17.4142 20 17.7071 19.7071C18 19.4142 18 18.9428 18 18V10M12.5 4L18 10M12.5 4V8C12.5 8.94281 12.5 9.41421 12.7929 9.70711C13.0858 10 13.5572 10 14.5 10H18"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinejoin="round"
  />,
  { viewBox: '0 0 24 24' },
);
